import React, {FC} from "react";
import {useField} from "formik";
import {useServices} from "./services.hook";
import {Checkbox, Divider, FormControlLabel, Grid, Typography} from "@material-ui/core";
import {useAppSelector} from "../../../redux/redux.hook";
import {selectWorkerById} from "../../workers/redux/workers.slice";

export const FormikServiceCheckBoxes: FC<{ name: string; label: string; workerId?: string }> = ({name, label, workerId}) => {
    const [, meta, helpers] = useField<string[]>(name);

    const addServiceId = (id: string) => helpers.setValue([...meta.value, id]);
    const removeServiceId = (id: string) => helpers.setValue(meta.value.filter((mId) => mId !== id));
    const worker = useAppSelector(state => selectWorkerById(state, workerId ?? ""));

    const services = useServices();

    console.log("services", services);
    console.log("worker", worker);

    return (
        <div>
            <Typography color={"textSecondary"} style={{ marginTop: 16 }}>{label}</Typography>
            <Divider style={{ marginBottom: 16, marginTop: 8}}/>
            <Grid container spacing={1}>
                {worker ?
                    services.filter(s => s.active && worker.servicesIds.includes(s.id)).map((service) => (
                            <Grid item xs={12} key={"service-grid-item-"+service.id}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={meta.value.includes(service.id)}
                                            onChange={(_event, checked) => checked
                                                ? addServiceId(service.id)
                                                : removeServiceId(service.id)
                                            }
                                        />
                                    }
                                    label={service.name}
                                />
                            </Grid>
                        ))
                    : services.filter(s => s.active).map((service) => (
                            <Grid item xs={12} key={"service-grid-item-"+service.id}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={meta.value.includes(service.id)}
                                            onChange={(_event, checked) => checked
                                                ? addServiceId(service.id)
                                                : removeServiceId(service.id)
                                            }
                                        />
                                    }
                                    label={service.name}
                                />
                            </Grid>
                        ))
                }

                {/*{services.filter(s => worker && worker.servicesIds.includes(s.id)).map((service) => (
                    <Grid item xs={12} key={"service-grid-item-"+service.id}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={meta.value.includes(service.id)}
                                    onChange={(_event, checked) => checked
                                        ? addServiceId(service.id)
                                        : removeServiceId(service.id)
                                    }
                                />
                            }
                            label={service.name}
                        />
                    </Grid>
                ))}*/}
            </Grid>
        </div>
    )
}